import { render, staticRenderFns } from "./ContactoPagina.vue?vue&type=template&id=438186ae&scoped=true"
import script from "./ContactoPagina.vue?vue&type=script&lang=ts"
export * from "./ContactoPagina.vue?vue&type=script&lang=ts"
import style0 from "./ContactoPagina.vue?vue&type=style&index=0&id=438186ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438186ae",
  null
  
)

export default component.exports